import { type FunctionComponentElement } from 'react';
import { createRoot, type Root } from 'react-dom/client';

import { getElement } from './get-element';

const rootsMap = new WeakMap<Element, Root>();

export const renderToNodeDecorator = (
  className: string,
  component: FunctionComponentElement<any>
) => {
  let element = getElement(`.${className}`);

  if (element) {
    // Unmount existing root before clearing
    const existingRoot = rootsMap.get(element);
    if (existingRoot) {
      existingRoot.unmount();
      rootsMap.delete(element);
    }
    element.innerHTML = '';
  } else {
    element = document.createElement('div');
    element.className = className;
    document.body.appendChild(element);
  }

  const root = createRoot(element);
  rootsMap.set(element, root);
  root.render(component);
};
